import { render, staticRenderFns } from "./CurrencyToggle.vue?vue&type=template&id=3dda598a&"
import script from "./CurrencyToggle.vue?vue&type=script&lang=ts&"
export * from "./CurrencyToggle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports